<template>
	<az-container>
		<cabecalho-anuencia :anuencia="anuencia"></cabecalho-anuencia>
		<az-container :class="classContainer">
			<v-row v-if="documentoAnuencia.isAssinado">
				<v-col cols="12">
					<div class="mensagem">
						<span class="box-aviso"
							><v-icon color="primary" class="mr-5">mdi-information</v-icon> Para visualizar o documento
							assinado, clique para baixar.</span
						>
						<v-btn color="primary" data-testid="baixar-btn" large @click="baixarDocumento()">Baixar </v-btn>
					</div>
				</v-col>
			</v-row>

			<iframe
				v-else-if="iframe.loaded && !isAdesaoConcluida"
				id="assinatura-iframe"
				:src="documentoAnuencia.url"
				class="responsive-iframe"
			></iframe>

			<v-row v-else>
				<v-col cols="12">
					<div class="mensagem">
						<span class="box-aviso" id="mensagem-adesao-concluida"
							><v-icon color="primary" class="mr-5">mdi-information</v-icon> Não será possível assinar a
							anuência, pois a adesão está concluída.</span
						>
					</div>
				</v-col>
			</v-row>
		</az-container>
	</az-container>
</template>
<script>
import descriptografaHash from '@/views/pages/adesao/anuenciaFornecedor/mixin/DescriptografaHash'
import cabecalhoAnuencia from '@/views/pages/adesao/anuenciaFornecedor/components/cabecalho/CabecalhoAnuencia.vue'
import ActionTypes from '@/core/constants/action-types'
import buscarAnuencia from '@/views/pages/adesao/anuenciaFornecedor/mixin/buscar-anuencia-mixin'
import AssinarDocumentoAnuenciaOutputData from '@/core/apiclient/anuencia/assinatura/models/AssinarDocumentoAnuenciaOutputData'
import BaixarDocumentoAnuenciaInput from '@/core/apiclient/anuencia/documento/models/BaixarDocumentoAnuenciaInput'

export default {
	name: 'etapa-assinatura-anuencia',
	components: { cabecalhoAnuencia },
	mixins: [descriptografaHash, buscarAnuencia],
	props: {
		etapa: {
			type: Number,
			default: () => 0,
		},
	},
	emits: ['ir-para-finalizar'],
	data() {
		return {
			anuencia: {},
			isDocumentoAssinado: false,
			documentoAnuencia: new AssinarDocumentoAnuenciaOutputData(),
			verificarAssinaturaComIntervalo: null,
			iframe: {
				loaded: false,
			},
		}
	},
	computed: {
		classContainer() {
			if (this.documentoAnuencia.isAssinado || this.isAdesaoConcluida) {
				return 'baixar-container'
			} else {
				return 'iframe-container'
			}
		},
	},
	watch: {
		isDocumentoAssinado(isAssinado) {
			if (isAssinado === true) {
				this.irParaEtapaFinalizacao()
			}
		},
		etapa(numero) {
			this.iframe.loaded = numero === 2
		},
	},
	async mounted() {
		const data = await this.verificarSituacaoDocFlowbee()
		this.documentoAnuencia = new AssinarDocumentoAnuenciaOutputData(data)
		await this.validarSeDocJaFoiAssinado()
	},
	beforeDestroy() {
		clearInterval(this.verificarAssinaturaComIntervalo)
	},
	methods: {
		async verificarSituacaoDocFlowbee() {
			return await this.$store.dispatch(ActionTypes.ANUENCIA.ASSINATURA.ASSINAR, this.getControleAnuencia())
		},
		async validarSeDocJaFoiAssinado() {
			if (!this.documentoAnuencia.isAssinado) {
				this.verificarAssinaturaComIntervalo = setInterval(async () => {
					await this.executarSemLoading(this.atualizarDocumentoAssinado)
				}, 3000)
			}
		},
		async atualizarDocumentoAssinado() {
			const { isAssinado } = await this.verificarSituacaoDocFlowbee()
			this.isDocumentoAssinado = isAssinado
			this.documentoAnuencia.isAssinado = isAssinado
		},
		async baixarDocumento() {
			const id = this.documentoAnuencia.idDocumentoAdesao
			const tipoRegistroDocumento = this.documentoAnuencia.tipoRegistroDocumento
			const situacaoDocumento = this.documentoAnuencia.situacaoDocumento

			await this.$store.dispatch(
				ActionTypes.ANUENCIA.DOCUMENTOS.BAIXAR_DOCUMENTO_ANEXO,
				new BaixarDocumentoAnuenciaInput(id, tipoRegistroDocumento, situacaoDocumento),
			)
		},
		irParaEtapaFinalizacao() {
			this.mostrarNotificacaoSucesso('Assinatura finalizada com sucesso!')
			this.$emit('ir-para-finalizar')
			clearInterval(this.verificarAssinaturaComIntervalo)
		},
	},
}
</script>
<style scoped lang="stylus">

.iframe-container {
	position: relative;
	overflow: auto;
	margin 0 !important
	width: 100%;
	padding-top: 30cm;
}

.baixar-container {
	margin 20px !important
}

.responsive-iframe {
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	width: 100%;
	height: 100%;
	border: none;
}

@media screen and (max-width: 768px) {
	.iframe-container {
		padding-top: 20cm;
	}
}

@media screen and (min-width: 1366px) and (max-width: 1919px) {
	.iframe-container {
		padding-top: 30cm;
	}
}

@media screen and (min-width: 1920px) {
	.iframe-container {
		padding-top: 30cm;
	}
}

.mensagem
	display flex
	flex-direction column
	align-items center
	padding 30px
	gap 30px

	.titulo
		font-weight bold
		color var(--v-primary-base)
		font-size 20px

	.box-aviso
		color var(--v-primary-base)
		font-weight bold
		display flex
		text-align center
		justify-content center
		flex-direction row
		align-items center
		align-content center
		width 100%
</style>
